import { render, staticRenderFns } from "./RiskExplorer.vue?vue&type=template&id=55055778&scoped=true&"
import script from "./RiskExplorer.vue?vue&type=script&lang=js&"
export * from "./RiskExplorer.vue?vue&type=script&lang=js&"
import style0 from "./RiskExplorer.vue?vue&type=style&index=0&id=55055778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55055778",
  null
  
)

export default component.exports